module.exports = __webpack_public_path__ + "img/PK.9b3b0efe.png";